/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$('.pdp-faq_item-title').click(function(e){
    $(this).toggleClass('active');
    $(this).next('.pdp-faq_item-content').slideToggle();
});

$(document).on('click', '.pdp-videos-list_item_play', function() {
    var videoElement = $(this).closest('.pdp-videos-list_item-wrapper').find('.pdp-videos-list_item-media')[0].outerHTML; // Get the parent .meta_video_block HTML
    console.log('videoElement',videoElement);
    $('.pdp-metavideo_main').html(videoElement); // Add the parent HTML into .metavideo_main
    $('.pdp-metavideo_popup').addClass('active'); // Show the popup by adding 'active' class
    $('.pdp-metavideo_main').find('video')[0].muted = false
});


$(document).on('click', '.pdp-metavideo_popup-close', function() {
    $('.pdp-metavideo_main').html(''); 
    $('.pdp-metavideo_popup').removeClass('active');
});

$(document).on('click', '.product-meta_offers-header', function() {
  $(this).toggleClass('active');
   $(this).next('.product-meta_offers-wrapper_content').slideToggle();
});

// REMOVE SEARCH INPUT ON CLICK
  $(document).on("click",".pre-search-input-clear", function (){
    const $wrapper = $(this).closest(".predictive-search-secondary");
    const searchWrap = $wrapper.find(".predictive-search__results");
    const searchFooter = $wrapper.find(".drawer__footer");
    console.log('searchFooter',searchFooter);
    searchWrap.attr("hidden", "hidden");
    searchFooter.attr("hidden", "hidden");
    $(this).removeClass("active");
    $(this).siblings('.predictive-search__input').val('');
    $("html").removeClass("lock-all");
  })

$(document).ready(function() {
  var swiperCollection = new Swiper(".curated-specially-nav", {
    slidesPerView: 3,
    enabled: false,
    navigation: {
        nextEl: ".curated-specially-swiper-button-next",
        prevEl: ".curated-specially-swiper-button-prev",
    },
    breakpoints: {
      1000: {
        enabled: true
      }
    }
  });

  var swiperCollection2 = new Swiper(".featured-product-list_grid", {
    slidesPerView: 1.3,
    navigation: {
        nextEl: ".curated-specially-swiper-button-next2",
        prevEl: ".curated-specially-swiper-button-prev2",
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true
    },
    breakpoints: {
      1000: {
        slidesPerView: 2,
      }
    }
  });

  $('body').on('click', '.curated-specially-nav-item-inr', function() {
    const Nav = $(this).data('nav');
    console.log('Nav',Nav);
    $(this).closest('.curated-specially-nav').find('.curated-specially-nav-item-inr').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.curated-specially-inner').find('.curated-specially-main-block').each(function() {
      const Tab = $(this).data('tab');
      console.log('Tab',Tab);
      if (Nav == Tab) {
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
      }
    })
  });

  var swiperCollection = new Swiper(".product-meta-fbt_product-items-list", {
    slidesPerView: 1.3,
    enabled: false,
    navigation: {
        nextEl: ".product-meta-fbt_body-swiper-button-next",
        prevEl: ".product-meta-fbt_body-swiper-button-prev",
    },
    breakpoints: {
      1000: {
        slidesPerView: 2.4,
        enabled: true
      }
    }
  });

  var swiperCollection2 = new Swiper(".awards-accreditaion-blocks", {
    slidesPerView: 1.3,
    enabled: false,
    navigation: {
        nextEl: ".awards-accreditaion-blocks-swiper-button-next",
        prevEl: ".awards-accreditaion-blocks-swiper-button-prev",
    },
    scrollbar: {
      el: '.awards-accreditaion-blocks-swiper-scrollbar',
      draggable: true
    },
    breakpoints: {
      1000: {
        slidesPerView: 3.4,
        enabled: true
      }
    }
  });

  //BUNDLE PAGE
  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
  function activecheck(addedcnt,bundle_price,bundle_compare_price){
    if(addedcnt == parseInt($('.bundle-product-list').attr('data-bundleitemcnt'))){
      $('.quantity-selector .quantity-selector__button:last-child').attr('disabled','disabled');
      $('.bundle-product-item__cta:not(.added)').attr('disabled','disabled');
      $('.bundle-add_to_cart_button').html(`<span class="loader-button__text"><span class="product-item__cta-text">Buy Bundle</span></span><span class="loader-button__loader"><div class="spinner"><svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg></div></span>`).addClass('readytoadd button--gradient').removeClass('button--outline');
      // $('.bundle-preview_cart-prices').show();
      var bundleamount = parseInt($('.bundle-preview_cart-prices').attr('data-off-price')) * 100;
      $('.bundle-preview_cart-prices .price--highlight').html(formatMoney(bundleamount, currencyFormat));
      $('.bundle-preview_cart-prices .price--compare').html(formatMoney(bundle_price, currencyFormat));
      var savings = bundle_price - bundleamount;
      // savings = Math.round(((savings) * 100) / bundle_price) + '%';
      $('.bundle-preview-cart-price-wrap .bundle-preview-cart-label').html(`Save ${formatMoney(savings, currencyFormat)}`);
    }else{
      $('.quantity-selector .quantity-selector__button:last-child').removeAttr('disabled');
      $('.bundle-product-item__cta:not(.added)').removeAttr('disabled');
      $('.bundle-add_to_cart_button').html('Buy Bundle').removeClass('readytoadd button--gradient');
      // $('.bundle-preview_cart-prices').hide();
      $('.bundle-preview_cart-prices .price--highlight').html(formatMoney(bundle_price, currencyFormat));
      $('.bundle-preview_cart-prices .price--compare').html(formatMoney(bundle_compare_price, currencyFormat));
      var bundleamount = parseInt($('.bundle-preview_cart-prices').attr('data-off-price')) * 100;
      var savings = bundle_compare_price - bundle_price;
      // savings = Math.round(((savings) * 100) / bundle_compare_price) + '%';
      $('.bundle-preview-cart-price-wrap .bundle-preview-cart-label').html(`Save ${formatMoney(savings, currencyFormat)}`);
    }
    
    

    $('#bundle-count-number').html(addedcnt);
    if(addedcnt > 0){
      $('.bundle-preview_cart').show();
    }else{
      $('.bundle-preview_cart').hide();
    }
  }

  var addedcnt = 0;
  var bundle_price = 0;
  var bundle_compare_price = 0;
  $('body').on('click', '.bundle-product-item__cta', function(e){
    e.preventDefault();
    addedcnt += 1;
    bundle_compare_price += parseInt($(this).closest('.product-item').attr('data-product-compareprice'));
    bundle_price += parseInt($(this).closest('.product-item').attr('data-product-price'));

    var prevval = $(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector input').val();
    $(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector input').val(parseInt(prevval) + 1);
    console.log(bundle_compare_price)
    activecheck(addedcnt,bundle_price,bundle_compare_price);    

    $(this).attr("disabled","disabled").addClass('added button--outline').removeClass('button--gradient').html(`Added`);
    // $(this).before(`<span class="bundle-product-item__cta-remove text--xsmall">x</span>`);

    var featuredimage = $(this).closest('.product-item').attr('data-featuredimage');
    var itembox = `<div class="bundle-preview_cart-item hasicon" 
    data-vid="${$(this).closest('.product-item').attr('data-variant-id')}"
    data-pid="${$(this).closest('.product-item').attr('data-product-id')}"
    data-price="${$(this).closest('.product-item').attr('data-product-price')}"
    data-compare_price="${parseInt($(this).closest('.product-item').attr('data-product-compareprice'))}"
    data-qty="1"
    >
      <div class="bundle-preview_cart-item-wrapper">
        <img src="${featuredimage}" loading="lazy" width="60" height="60" alt="">
        <div class="bundle-preview_car-item-remove text--xsmall">x</div>
        <div class="bundle-preview_car-item-qty text--xsmall">x1</div>
      </div>
    </div>`;
    $('.bundle-preview_cart-items').append(itembox);
    // $(this).hide().closest('.bundle-product-item__cta-wrapper').find('.quantity-selector').show();
    $(this).find('.product-item__cta-text').html(`Added`);
    $(this).siblings('.bunle-product-item-remove').addClass('active');

    
    // var itembox = `<div class="bundle-preview_cart-item-wrapper">
    // <img src="${featuredimage}" loading="lazy" width="50" height="50" alt=""><div class="bundle-preview_car-item-remove text--xsmall">x</div></div>`; 

    // $('.bundle-preview_cart-item.hasblank').first().html(itembox);
    // $('.bundle-preview_cart-item.hasblank').first().attr('data-vid',$(this).closest('.product-item').attr('data-variant-id')).attr('data-pid',$(this).closest('.product-item').attr('data-product-id')).attr('data-price',$(this).closest('.product-item').attr('data-product-price')).removeClass('hasblank');    
  });

  // $('body').on('click', '.bundle-product-item__cta-wrapper .quantity-selector .quantity-selector__button:last-child', function(e){
  //   e.preventDefault();
  //   addedcnt += 1;    
  //   var prevval = $(this).closest('.quantity-selector').find('input').val();
  //   bundle_compare_price += parseInt($(this).closest('.product-item').attr('data-product-compareprice'));
  //   bundle_price += parseInt($(this).closest('.product-item').attr('data-product-price'));
  //   activecheck(addedcnt,bundle_price,bundle_compare_price);
  //   $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').attr('data-qty',prevval).find('.bundle-preview_car-item-qty').html(`x${prevval}`);
  // });

  // $('body').on('click', '.bundle-product-item__cta-wrapper .quantity-selector .quantity-selector__button:first-child', function(e){
  //   e.preventDefault();    
  //   addedcnt = addedcnt - 1;
  //   var prevval = parseInt($(this).closest('.quantity-selector').find('input').val());
  //   bundle_compare_price = bundle_compare_price - parseInt($(this).closest('.product-item').attr('data-product-compareprice'));
  //   bundle_price = bundle_price - parseInt($(this).closest('.product-item').attr('data-product-price'));
  //   activecheck(addedcnt,bundle_price,bundle_compare_price); 
  //   if(prevval == 0){
  //     console.log('iffff');
  //     $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').remove();  
  //     // $(this).closest('.quantity-selector').hide();
  //     $(this).find('.product-item__cta-text').html(`Add To Box`);
  //     $(this).siblings('.bunle-product-item-remove').removeClass('active');
  //     $(this).closest('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').show();
  //   }else{
  //     $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').attr('data-qty',prevval).find('.bundle-preview_car-item-qty').html(`x${prevval}`);
  //   }
  // });

  $('body').on('click', '.bunle-product-item-remove', function(e){
    e.preventDefault();    
    addedcnt = addedcnt - 1;
    var prevval = 0;
    bundle_compare_price = bundle_compare_price - parseInt($(this).closest('.product-item').attr('data-product-compareprice'));
    bundle_price = bundle_price - (parseInt($(this).closest('.product-item').attr('data-product-price')) * parseInt($('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').attr('data-qty')));   
    console.log(bundle_price);
    activecheck(addedcnt,bundle_price,bundle_compare_price);
    console.log('dfdfdfdf',prevval);
    if(prevval == 0){
      console.log('iffff');
      $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').remove(); 
      $(this).siblings('.bundle-product-item__cta').removeAttr("disabled").removeClass('added button--outline').addClass('button--gradient');
      $(this).siblings('.bundle-product-item__cta').html(`Add To Box`); 
      $(this).removeClass('active');
    }else{
      $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').attr('data-qty',prevval).find('.bundle-preview_car-item-qty').html(`x${prevval}`);
    }

    // $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.quantity-selector').hide().find('input').val(0);
    // $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.bundle-product-item__cta').show();
    // $(this).closest('.bundle-preview_cart-item').prev().remove();
    // $(this).closest('.bundle-preview_cart-item').remove();

    // $(this).siblings('.bundle-product-item__cta').removeAttr("disabled").removeClass('added button--outline').addClass('button--gradient').html(`Add to box`);
    // // $(`.bundle-preview_cart-item[data-pid="${$(this).closest('.product-item').attr('data-product-id')}"]`).addClass('hasblank').removeAttr('data-pid').removeAttr('data-vid').removeAttr('data-price').html('<div class="bundle-preview_cart-item-wrapper">Add</div>');
    // $(this).remove();
  });

  $('body').on('click','.bundle-preview_car-item-remove', function(){
    addedcnt = addedcnt - $(this).closest('.bundle-preview_cart-item').attr('data-qty');
    bundle_compare_price = bundle_compare_price - (parseInt($(this).closest('.bundle-preview_cart-item').attr('data-compare_price')) * parseInt($(this).closest('.bundle-preview_cart-item').attr('data-qty')));
    bundle_price = bundle_price - (parseInt($(this).closest('.bundle-preview_cart-item').attr('data-price')) * parseInt($(this).closest('.bundle-preview_cart-item').attr('data-qty')));   
    console.log(bundle_price);
    activecheck(addedcnt,bundle_price,bundle_compare_price); 

    $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.quantity-selector').hide().find('input').val(0);
    $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.bundle-product-item__cta').html(`Add To Box`).removeAttr("disabled").removeClass('added button--outline').addClass('button--gradient');
    $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.bundle-product-item__cta').siblings('.bunle-product-item-remove').removeClass('active');
    $(this).closest('.bundle-preview_cart-item').remove();
  });

  document.addEventListener('cart:updated', function(event) {
    var cart = event.detail.cart; // Get the updated content of the cart
    var packging_item = window.customthemeVariables.cartsettings.packging_item;
    var haspackateitem = cart.items.filter(function(item){
      return item.id == packging_item['variants'][0].id
    });
    console.log(haspackateitem);
    if(cart['item_count'] == 1 && haspackateitem.length > 0){
      var updateData = {};        
      updateData[packging_item['variants'][0].id] = 0;
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          updates: updateData
        },
        dataType: 'json',
        async: true,
        error: function (jqXHR, textStatus, errorThrown) {
          console.log('error')            
        },
        success: function(data) {   
          console.log('success')
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true
          }));
        }
        
      });
    }
  });

  $('body').on('click','.bundle-add_to_cart_button.readytoadd', function(){
    $(this).attr("aria-busy",true);
    var items = [];
    $(this).closest('.bundle-preview_cart-main').find('.bundle-preview_cart-item:not(.hasblank)').each(function(i,v){
      var val = $(this).attr('data-vid');         
      var qty = $(this).attr('data-qty');         
       items.push({
        quantity: qty,
        id: val
      });   
    });      
    
    var data = {items};
    console.log('data',data)
    // var data = theme.utils.serialize(this.form);
   
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {      
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      // document.getElementById('mini-cart').open = true;
      onCheckoutClick(this);
      $(this).removeAttr("aria-busy");
      $('.bundle-product-item__cta-wrapper').find('.quantity-selector').hide().find('.quantity-selector__input').val(0);
      $('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').show();
      $('.bundle-preview_cart-items .bundle-preview_cart-item').remove();
      $('.bundle-product-item__cta').removeAttr("disabled").removeClass('added button--outline').addClass('button--gradient');
      $('.bundle-product-item__cta').html(`Add To Box`); 
      $('.bunle-product-item-remove').removeClass('active');
      addedcnt = 0;
      bundle_price = 0;
      activecheck(0,bundle_price,bundle_compare_price);     
    }.bind(this));  
    
  });

  $("body").on("click", ".product-meta_offers-item_copy-code", function () {
    var copy_text = $(this);
    var text = $(this).attr('code');
    var $temp = $("<input>");
      
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html('Copied');
      
    setTimeout(function () {
      copy_text.html('Copy');
    }, 1000);
  });

  $("body").on("click", ".product-meta-share-button", function (){
    $('html').addClass('lock-all');
    $(this).closest('.product-meta_share_wraper').find('.product-meta-share-modal').attr('open', '');
  })
  $("body").on("click", ".product-meta-share-button-close, .product-meta-share-overlay", function (){
    $('html').removeClass('lock-all');
    $(this).closest('.product-meta_share_wraper').find('.product-meta-share-modal').removeAttr('open', '');
  })
  $('body').on('click', '.product-meta__share-button-item--copylink', function(e) {
    e.preventDefault();  
    var copy_text = $(this).find(".show_copied_text");
    var link = $(this).attr('href');  
    var $tempInput = $('<input>');
    $('body').append($tempInput);
    $tempInput.val(link).select();
    document.execCommand('copy');
    $tempInput.remove();
    copy_text.html("Link copied"); 
    setTimeout(function () {
      copy_text.html("");
    }, 1000);
  });

  $('body').on('click', '.product-meta_best_buy-copy_code', function(e) {
    e.preventDefault();

    var $btn = $(this);
    var text = $btn.attr('code');

    // 👉 original text store karo (first time only)
    if (!$btn.data('original-text')) {
      $btn.data('original-text', $btn.html());
    }

    navigator.clipboard.writeText(text).then(function() {
      $('.product-meta-best-buy-coped').text("Copied");

      setTimeout(function () {
        $('.product-meta-best-buy-coped').text("");
      }, 1500);
    });
  });

  $("body").on("click", ".product-meta-accordion-title", function () {
    var activeTitle = $(this);
    activeTitle.toggleClass("active");
    var currentDropdown = activeTitle.next(".product-meta-accordion-content");
    $(".product-meta-accordion-title").not(activeTitle).removeClass("active");
    $(".product-meta-accordion-content").not(currentDropdown).slideUp();
    currentDropdown.stop(true, true).slideToggle();
  });

})

if ($('body').hasClass('template-collection')) {
  var pInfScrLoading = false;
  function pInfScrExecute() {
    var pInfScrNode = $('.product-list__inner.grid_view_custom').find('.more');
    var $btn = $('.collection-load-more-btn');

    if (!pInfScrLoading && pInfScrNode.length > 0) {

      var pInfScrURL = pInfScrNode.find('a').attr("href");

      pInfScrNode.remove();
      $btn.text('');

      $btn.append('<img src="https://cdn.shopify.com/s/files/1/0639/5225/7283/files/Spinner_1.gif?v=1774008697" class="infinite-scroll-loader scroll_loading" />');

      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function () {
          pInfScrLoading = true;
          console.log('loading...');
        },
        success: function (data) {

          var filteredData = $(data).find(".product-list__inner");
          $('.product-list__inner.grid_view_custom').append(filteredData.html());

          $btn.find('.scroll_loading').remove();
          pInfScrLoading = false;
          $btn.text('Load More');
          var newMoreBtn = $(data).find('.more');
          if (newMoreBtn.length === 0) {
            // Last page → hide button permanently
            $('.collection-load-more-btn').hide();
          } else {
            // More pages available → show button
            $('.collection-load-more-btn').show();
          }

          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        },
        dataType: "html"
      });
    }
  }

  // CLICK EVENT
  $(document).on('click', '.collection-load-more-btn', function () {
    pInfScrExecute();
  });
  if (pInfScrNode.length === 0) {
    $('.collection-load-more-btn').hide();
  }
}

/* OpenAI Ads attribution: keep the ChatGPT click reference on the cart so it reaches the order */
;(function () {
  function ck(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; }
  var busy = false;
  function sync() {
    var ob = ck('__obref'), op = ck('__oppref');
    if ((!ob && !op) || busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var a = c.attributes || {}, u = {};
      if (ob && a._obref !== ob) u._obref = ob;
      if (op && a._oppref !== op) u._oppref = op;
      if (!Object.keys(u).length) return;
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: u }) });
    }).catch(function () {}).then(function () { busy = false; });
  }
  sync();
  setTimeout(sync, 4000);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') sync(); });
})();
